// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"196":"models","271":"playground","942":"not-found"}[chunkId] + "." + {"196":"0b944929","271":"778bbb6d","942":"ba150069"}[chunkId] + ".css";
};